import { useState } from 'react'
import { apiPost } from '../../api/client'
import { trackUnsubscribe } from '../../analytics/posthog'
import { useT } from '../../i18n/useT'
import { Modal } from '../ui/Modal'
import { Button } from '../ui/Button'

interface CancelSubscriptionModalProps {
  isOpen: boolean
  onClose: () => void
  onCancelled: () => void
}

export function CancelSubscriptionModal({ isOpen, onClose, onCancelled }: CancelSubscriptionModalProps) {
  const t = useT()
  const [isLoading, setIsLoading] = useState(false)
  const [failed, setFailed] = useState(false)

  async function handleCancel() {
    setIsLoading(true)
    setFailed(false)
    trackUnsubscribe()
    try {
      await apiPost('/subscriptions/cancel')
      onCancelled()
      onClose()
    } catch {
      // A silent failure here would read as a successful cancellation
      setFailed(true)
    } finally {
      setIsLoading(false)
    }
  }

  function close() {
    setFailed(false)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={close} title={t('cancelSub.title')}>
      <div className="py-2">
        <p className="text-sm text-text-secondary mb-6">{t('cancelSub.body')}</p>
        {failed && <p className="text-sm text-error mb-4">{t('cancelSub.error')}</p>}
        <div className="flex gap-3">
          <Button variant="secondary" onClick={onClose} className="flex-1">
            {t('cancelSub.keep')}
          </Button>
          <Button
            onClick={handleCancel}
            isLoading={isLoading}
            className="flex-1 !bg-error hover:!bg-error/90"
          >
            {t('cancelSub.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
